import { axiosAiq } from 'config';

// Above the BE's own Condor read timeout (45 s), so the agent gets the BE's answer rather than a client timeout.
export const OCR_EXTRACTION_REQUEST_TIMEOUT_MS = 60000;

/**
 * Asks the BE to read one identifier from one uploaded OCR snapshot through Condor. Condor outcomes, failures
 * included, come back as 200 with a `status`; a non-2xx means the request itself did not fit the transaction.
 */
export const requestOcrExtraction = async (transactionId, { assetId, identifier, clientAttemptId }) => {
    const response = await axiosAiq.post(
        `/transactions/trucks/${transactionId}/ocr-extractions`,
        { assetId, identifier, clientAttemptId },
        { timeout: OCR_EXTRACTION_REQUEST_TIMEOUT_MS }
    );
    return response.data;
};
